import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { CategoryDto, UpdateCategoryDto } from '../types';

export const useUpdateCategory = (projectUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation<CategoryDto, Error, { uuid: string; data: UpdateCategoryDto }>({
    mutationFn: ({ uuid, data }) =>
      apiClient.patch(`/v1/projects/${projectUuid}/categories/${uuid}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories', projectUuid] });
    },
  });
};
